export default __webpack_public_path__ + "close-Icon.0c65e546.svg";